// extracted by mini-css-extract-plugin
module.exports = {"block":"cases-slide_block__9Je5M"};